import { render, staticRenderFns } from "./WorkflowTable.vue?vue&type=template&id=9f353926&scoped=true&"
import script from "./WorkflowTable.vue?vue&type=script&lang=js&"
export * from "./WorkflowTable.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "9f353926",
  null
  
)

export default component.exports